<edu-card>
  <img alt="alternative" [src]="img" class="img-icon" />
  <p class="content-text">{{ this.content }}</p>
  <div class="title-row">
    <h4 class="title">{{ title }}</h4>
    @if (this.showNext) {
      <mat-icon svgIcon="arrow-right" class="icon"></mat-icon>
    }
  </div>
</edu-card>
